<template>
  <div>
      <button class="cart-fab" @click="showCart = true" aria-label="Ver carrito">
      <svg viewBox="0 0 24 24" class="cart-icon">
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
      <span v-if="totalItems > 0" class="cart-count">{{ totalItems }}</span>
    </button>
    <Teleport to="body">
    <div v-if="showCart" class="cart-modal-bg" @click.self="showCart = false">
      <div class="cart-modal">
        <h2>Carrito de compras</h2>
        <div v-if="cart.length === 0" class="cart-empty">Tu carrito está vacío.</div>
        <ul v-else class="cart-list">
          <li v-for="(item, i) in cart" :key="i" class="cart-item">
            <div class="cart-item-info">
              <span class="item-name">{{ item.textProducts }}</span>
              <span class="item-qty">Cantidad: {{ item.quantity || 1 }}</span>
            </div>
            <button class="remove-btn" @click="removeFromCart(i)">✕</button>
          </li>
        </ul>
        <button v-if="cart.length" class="clear-cart-btn" @click="clearCart">
          Vaciar carrito
        </button>
        <button v-if="cart.length" class="whatsapp-btn" @click="checkoutWhatsapp">
          Finalizar compra por WhatsApp
        </button>
        <button class="close-btn" @click="showCart = false">Cerrar</button>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<script>
import { supabase } from '@/supabase'

export default {
  name: 'Cart',
  data() {
    return {
      showCart: false,
      cart: JSON.parse(localStorage.getItem('cart') || '[]'),
      onStorageCartUpdate: null,
      onCustomCartUpdate: null,
      onOpenCartModal: null
    };
  },
  computed: {
    totalItems() {
      return this.cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
    }
  },
  mounted() {
    this.onStorageCartUpdate = () => {
      this.cart = JSON.parse(localStorage.getItem('cart') || '[]');
    };
    this.onCustomCartUpdate = () => {
      console.log('Cart update detected in component');
      this.cart = JSON.parse(localStorage.getItem('cart') || '[]');
    };
    this.onOpenCartModal = () => {
      this.cart = JSON.parse(localStorage.getItem('cart') || '[]');
      this.showCart = true;
    };

    window.addEventListener('storage', this.onStorageCartUpdate);
    window.addEventListener('cart-updated', this.onCustomCartUpdate);
    window.addEventListener('open-cart-modal', this.onOpenCartModal);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorageCartUpdate);
    window.removeEventListener('cart-updated', this.onCustomCartUpdate);
    window.removeEventListener('open-cart-modal', this.onOpenCartModal);
  },
  methods: {
    removeFromCart(index) {
      this.$store.dispatch('removeFromCart', index)
    },
    clearCart() {
      this.$store.dispatch('clearCart')
    },
    checkoutWhatsapp() {
      const phone = '573228463663';
      const header = '¡Hola! Quiero comprar estos productos:\n\n';
      const items = this.cart.map(p => {
        const qty = p.quantity || 1;
        return `✅ ${qty}x ${p.textProducts} (Ref: ${p.textId})`;
      }).join('\n');

      const totalAmount = this.cart.reduce((acc, p) => {
        const qty = Number(p.quantity || 1);
        const unit = Number(p.price || 0);
        return acc + (qty * unit);
      }, 0);

      const orderCode = `WA-${Date.now()}`;

      const msg = encodeURIComponent(
        header +
        items +
        `\n\nTotal de artículos: ${this.totalItems}` +
        `\nCódigo de orden: ${orderCode}`
      );

      // Abre WhatsApp de forma síncrona para que no sea bloqueado en móvil
      window.open(`https://wa.me/${phone}?text=${msg}`, '_blank');

      // Registro en DB en segundo plano (no bloquea la apertura de WhatsApp)
      const payloadEs = {
        orden_codigo: orderCode,
        canal: 'WhatsApp',
        estado: 'pendiente',
        total_items: this.totalItems,
        total: totalAmount,
        detalle: JSON.stringify(this.cart)
      };
      const payloadEn = {
        order_code: orderCode,
        channel: 'WhatsApp',
        status: 'pending',
        total_items: this.totalItems,
        total: totalAmount,
        details: JSON.stringify(this.cart)
      };

      supabase.from('ventas').insert([payloadEs]).then(({ error }) => {
        if (error) return supabase.from('ventas').insert([payloadEn]);
      }).then((res) => {
        if (res && res.error) return supabase.from('sales').insert([payloadEn]);
      }).then((res) => {
        if (!res || !res.error) window.dispatchEvent(new Event('sales-created'));
      }).catch(err => {
        console.warn('Error registrando venta:', err.message);
      });
    }
  },
  watch: {
    cart: {
      handler(newCart) {
        localStorage.setItem('cart', JSON.stringify(newCart));
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.cart-fab {
  background: #ffffff;
  border: 1.5px solid #005bea;
  color: #005bea;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s ease;
  padding: 0;
  margin: 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  flex-shrink: 0;
}

.cart-fab:hover {
  background: #f0f7ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,91,234,0.1);
}

.cart-icon {
  width: 22px;
  height: 22px;
  fill: currentColor;
}

.cart-count {
  background: #e53935;
  color: #fff;
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.cart-modal-bg {
  position: fixed;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(2px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}


.cart-modal {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  position: relative;
  display: flex;
  flex-direction: column;
}

.cart-modal h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}

.cart-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
  color: #444;
}

.cart-item-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-name {
  font-weight: 600;
  color: #1e293b;
}

.item-qty {
  font-size: 12px;
  color: #64748b;
}

.remove-btn {
  background: #fff0f0;
  border: none;
  color: #e53935;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.remove-btn:hover {
  background: #ffe0e0;
}

.clear-cart-btn {
  background: #fff0f0;
  color: #d32f2f;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 16px;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.clear-cart-btn:hover {
  background: #ffe6e6;
  border-color: #ef9a9a;
}

.whatsapp-btn {
  background: #25d366;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 20px;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.whatsapp-btn:hover {
  background: #1eb956;
}

.close-btn {
  background: #f5f5f5;
  color: #666;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #eeeeee;
}

.cart-empty {
  color: #888;
  text-align: center;
  margin: 1.5rem 0;
}
</style>
